var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5034 13.7383L12.2118 11.4979L12.1581 11.4162C12.0582 11.3168 11.9216 11.2608 11.7791 11.2608C11.6366 11.2608 11.5 11.3168 11.4002 11.4162C9.45266 13.2029 6.45177 13.3 4.38768 11.6431C2.32358 9.98627 1.83679 7.08956 3.25013 4.8741C4.66348 2.65863 7.53839 1.81188 9.96824 2.89541C12.3981 3.97893 13.6289 6.65651 12.8444 9.15238C12.7879 9.33269 12.834 9.52877 12.9655 9.66676C13.097 9.80475 13.2937 9.86369 13.4817 9.82138C13.6697 9.77906 13.8203 9.64192 13.8768 9.46161C14.8146 6.49975 13.3982 3.31235 10.5438 1.96136C7.68934 0.610359 4.25357 1.5012 2.45904 4.0576C0.664521 6.61399 1.04979 10.0687 3.36563 12.187C5.68146 14.3052 9.23286 14.4512 11.7224 12.5306L13.7514 14.5143C13.961 14.7183 14.2998 14.7183 14.5093 14.5143C14.7187 14.3075 14.7187 13.9744 14.5093 13.7675L14.5034 13.7383Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.3d342ee70faa71df23c3eb844a4ba79b.svg";
export { ForwardRef as ReactComponent };